(function () {
    // Load check
    if (!jQuery) {
        console.log('NOT LOADED!');
        return;
    }
    
    (function ($) {
        window.OferaCRM = window.OferaCRM || {};
        OferaCRM.FE = OferaCRM.FE || {};
        OferaCRM.FE.Main = {
            elements: {
                $locationPicker: $('.js-location-picker'),          // Parent of the location elements 
                $locationField: $('.js-location-field'),            // Field where location id is located
                $locationSelector: $('.js-location-selector'),      // Field where location is being input and selected
                $autosuggestList: $('.js-autosuggest-list'),        // Autosuggest dropdown list element
                $customTabContainers: $('.js-tab-container')        // Tab containers for custom behavior
            }
        };
        
        var localeData = localStorage.getItem('localeData');
        OferaCRM.localeData = [];
        if (localeData) {
            OferaCRM.localeData = JSON.parse(localeData);
        }
        
        $.ajax({
            url: window.BASE_URL + '/date-localizare-timestamp',
            method: 'GET'
        }).done(function(serverLocaleDataTimestamp) {
            var latestUpdateLocaleData = localStorage.getItem('latestUpdateLocale');
            if (!localeData || !latestUpdateLocaleData || latestUpdateLocaleData !== serverLocaleDataTimestamp) {
                console.log('Missing locale data or old set.', 'Local latest: ' + latestUpdateLocaleData, 'Server latest: ' + serverLocaleDataTimestamp);
                localStorage.setItem('latestUpdateLocale', serverLocaleDataTimestamp);
                $.ajax({
                    url: window.BASE_URL + '/date-localizare',
                    method: 'GET',
                    contentType: 'application/json; charset=utf8',
                    dataType: 'json'
                }).done(function(data) {
                    data.forEach(function (el) {
                        el.searchName = el.name.replace(/Ă/g, 'A'); 
                        el.searchName = el.searchName.replace(/Â/g, 'A'); 
                        el.searchName = el.searchName.replace(/Î/g, 'I'); 
                        el.searchName = el.searchName.replace(/Ș/g, 'S'); 
                        el.searchName = el.searchName.replace(/Ț/g, 'T'); 
                        el.name = el.name.toLowerCase().replace(/(?:^|\s|\-)\w/g, function(match) {
                            return match.toUpperCase();
                        });

                        if (el.loc.length) {
                            el.loc.forEach(function (el) {
                                el.searchName = el.name.replace(/Ă/g, 'A'); 
                                el.searchName = el.searchName.replace(/Â/g, 'A'); 
                                el.searchName = el.searchName.replace(/Î/g, 'I'); 
                                el.searchName = el.searchName.replace(/Ș/g, 'S'); 
                                el.searchName = el.searchName.replace(/Ț/g, 'T'); 
                                el.name = el.name.toLowerCase().replace(/(?:^|\s|\-)\w/g, function(match) {
                                    return match.toUpperCase();
                                });
                            });
                        }
                    });
                    localStorage.setItem('localeData', JSON.stringify(data));
                    OferaCRM.localeData = data;
                    console.log('Locale data updated.');
                }).fail(function(error) {
                    console.log(error.responseText);
                });
            }
        }).fail(function(error) {
            console.log(error.responseText);
        });
        
        $(document).ready(function () {
            var self = OferaCRM.FE.Main;
            var E = self.elements;

            var $cookiesWarning = $(".js-cookies-warning");
            var $acceptCookieButton = $(".js-accept-cookie");
            if ($acceptCookieButton.length && $cookiesWarning.length) {
                var cookie = document.cookie;

                if (cookie.indexOf('accept_cookies') === -1) {
                    $cookiesWarning.fadeIn();
                }
                
                $acceptCookieButton.on('click', function () {
                    var date = new Date();
                    date.setYear(date.getFullYear() + 1);
                    document.cookie = "accept_cookies=yes;expires: " + date.toUTCString() + ";path=/";
                    $cookiesWarning.fadeOut();
                });
            }
            
            if (E.$locationSelector.length > 0) {
                E.$locationSelector.on('focus', function() {
                    var $this = $(this);
                    var val = $this.val();
                    var countyIndex = val.indexOf('(județ)');
                    if (countyIndex > 1) {
                        $this.val(val.substr(0, countyIndex - 1));
                    }
                });
                E.$locationSelector.on('keyup', function() {
                    var $this = $(this);
                    var $locationPicker = $this.closest('.js-location-picker');
                    var $autosuggestList = $locationPicker.find('.js-autosuggest-list');
                    if ($this.val().length < 3) {
                        $locationPicker.find('.js-location-field').val('');
                        $autosuggestList.html('');
                        $autosuggestList.hide();
                        return;
                    }
                    var searchTerm = $this.val().toUpperCase();
                    searchTerm = searchTerm.replace(/Ă/g, 'A'); 
                    searchTerm = searchTerm.replace(/Â/g, 'A'); 
                    searchTerm = searchTerm.replace(/Î/g, 'I'); 
                    searchTerm = searchTerm.replace(/Ș/g, 'S'); 
                    searchTerm = searchTerm.replace(/Ț/g, 'T');

                    var results = [];

                    OferaCRM.localeData.forEach(function (county) {
                        if ($this.data('also-county') === 'yes') {
                            if (county.searchName.indexOf(searchTerm) === 0) {
                                results.push({
                                    id: county.id,
                                    name: county.name,
                                    seokey: county.name.toLowerCase(),
                                    isCounty: 1,
                                    displayName: '<span class="e-location-name">Toate din județul ' + county.name + '</span>'
                                });
                            }
                        }
                        county.loc.forEach(function (location) {
                            if (location.searchName.indexOf(searchTerm) === 0) {
                                results.push({
                                    id: location.id,
                                    name: location.proper,
                                    rang: location.rang,
                                    seokey: location.seo_key,
                                    isCounty: 0,
                                    displayName: '<span class="e-location-name">' + location.proper + '</span>' +
                                        '<span class="e-location-county">, județul ' + county.name + '</span>'
                                });
                            }
                        });
                    });

                    results.sort(function (a, b) {
                        if ($this.data('also-county') === 'yes') {
                            if (!a.isCounty && b.isCounty) {
                                return 1;
                            }

                            if (a.isCounty && !b.isCounty) {
                                return -1;
                            }
                        }

                        if (a.rang > b.rang) {
                            return 1;
                        }

                        if (a.rang < b.rang) {
                            return -1;
                        }

                        return a.name > b.name;
                    });

                    var displayedResults = results.splice(0,7);

                    $autosuggestList.html('');
                    if (displayedResults.length) {
                        $autosuggestList.show();
                        displayedResults.forEach(function (result) {
                            $autosuggestList.append('<li class="b-suggestion" '+
                                'data-county="' + result.isCounty + '" ' +
                                'data-id="' + result.id + '" ' + 
                                'data-name="' + result.name + '" '+
                                'data-seokey="' + result.seokey + '">' + 
                                result.displayName + 
                                '</li>');
                        });
                    } else {
                        $autosuggestList.hide();
                        $locationPicker.find('.js-location-field').val('');
                    }
                });
            }

            if (E.$autosuggestList.length) {
                E.$autosuggestList.on('click', 'li', function () {
                    var $this = $(this);
                    var $locationPicker = $this.closest('.js-location-picker');
                    $locationPicker.find('.js-location-field').val($this.data('id'));

                    $('#searchmodel-auto').val($this.data('name'));
                    if (parseInt($this.data('county'), 10) === 1) {
                        $locationPicker.find('.js-location-selector').val($this.data('name') + ' (județ)');
                        $locationPicker.find('.js-location-county-field').val($this.data('id'));
                        $locationPicker.find('.js-county-seo').val($this.data('seokey'));
                        $locationPicker.find('.js-location-field').val('');
                        $locationPicker.find('.js-city-seo').val('');
                    } else {
                        $locationPicker.find('.js-location-selector').val($this.data('name'));
                        $locationPicker.find('.js-location-field').val($this.data('id'));
                        $locationPicker.find('.js-city-seo').val($this.data('seokey'));
                        $locationPicker.find('.js-location-county-field').val('');
                        $locationPicker.find('.js-county-seo').val('');
                    }
                    
                    var $autosuggestList = $locationPicker.find('.js-autosuggest-list');
                    $autosuggestList.html('');
                    $autosuggestList.hide();
                });
            }
            
            if (E.$customTabContainers.length) {
                OferaCRM.FE.Utils.customTabs();
            }
        });
    })(jQuery);
})();


window.OferaCRM = window.OferaCRM || {};
OferaCRM.FE = OferaCRM.FE || {};

OferaCRM.FE.Utils = {
    
    showLogs: true,
    
    updateHtmlContents: function ($element, newHtml) {
        if (!$element || !$element.length) {
            //OferaCRM.FE.Debug.err('PC-0031', 'Trying to set html into an inexistent element.');
            return false;
        }
        
        $element.html(newHtml);
        return true;
    },
    
    updateInput: function ($element, newValue, attribute, attributeValue) {
        if (!$element || !$element.length) {
            return //OferaCRM.FE.Debug.err('PC-0035', 'Trying to update an inexistent input.');
        }
        
        $element.val(newValue);
        if (!attribute) {
            return;
        }
        
        if (!attributeValue) {
            attributeValue = attribute;
        }
        
        if (attributeValue === OferaCRM.FE.Values.REMOVE) {
            $element.removeAttr(attribute);
            return;
        }
        
        $element.attr(attribute, attributeValue);
    },
    
    capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    
    engOnly: function (str) {
        var s = str.replace(/ă/g, 'a');
        s = s.replace(/â/g, 'a');
        s = s.replace(/ș/g, 's');
        s = s.replace(/ț/g, 't');
        s = s.replace(/Ă/g, 'A');
        s = s.replace(/Â/g, 'A');
        s = s.replace(/Ș/g, 'S');
        s = s.replace(/Ț/g, 'T');
        return s;
    },
    
    prepareForMatch: function (str) {
        var self = OferaCRM.FE.Utils;
        
        return self.engOnly(str).toUpperCase();
    },
    
    interpretUrl: function (url) {
        var result = {};
        
        var urlArray = url.split('?');
        
        result.base = urlArray[0];
        result.params = [];
        
        var paramsArray = urlArray[1].split('&');
        
        if (Array.isArray(paramsArray) && paramsArray.length) {
            paramsArray.forEach(function (pKeyValue) {
                var keyValue = pKeyValue.split('=');
                var param = {
                    key: keyValue[0],
                    value: keyValue[1]
                }
                result.params.push(param);
            });
        }
        
        return result;
    },
    
    rebuildUrl: function (urlObject) {
        var url = urlObject.base + '?';
        var pairsArray = [];
        
        if (Array.isArray(urlObject.params) && urlObject.params.length) {
            urlObject.params.forEach(function (param) {
                pairsArray.push(param.key + '=' + param.value);
            });
        }
        
        url += pairsArray.join('&');
        return url;
    },
    
    customTabs: function () {
        console.log('Setting up custom tabs...');
        var $tabContainersOnPage = $('.js-tab-container');
        
        $tabContainersOnPage.each(function () {
            var $tabContainer = $(this);
            
            // Init
            var firstContentId = $tabContainer.find('.js-tab-header.active').data('contentid');
            $tabContainer.find('.js-tab-content').hide();
            $tabContainer.find('#' + firstContentId).show();            
            
            // Event
            $tabContainer.on('click', '.js-tab-header', function () {
                var $this = $(this);
                if ($this.hasClass('active')) {
                    return;
                }
                
                $tabContainer.find('.js-tab-header').removeClass('active');
                $this.addClass('active');
                
                var contentId = $this.data('contentid');
                
                $tabContainer.find('.js-tab-content').hide();
                $tabContainer.find('#' + contentId).show();
            });
        })
    }
};